// extracted by mini-css-extract-plugin
export default {"cant-manage-message":"style_cant-manage-message__B2Q0-","cantManageMessage":"style_cant-manage-message__B2Q0-"};